module.exports = __webpack_public_path__ + "static/the-last-unknowns-75a03ba54227e329643073474edaa740.jpg";